// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const mapStateToProps = ({ auth: { isAuthenticated } }) => ({
  isAuthenticated,
});

type Props = {
  isAuthenticated: boolean,
};

export default (ComposedComponent: React.ComponentType<*>) => {
  class Authenticate extends React.Component<Props> {
    static contextTypes = {
      router: PropTypes.object.isRequired,
    };

    componentWillMount() {
      if (!this.props.isAuthenticated) {
        this.context.router.history.push('/login');
      }
    }

    componentWillUpdate(nextProps: Props) {
      if (!nextProps.isAuthenticated) {
        this.context.router.history.push('/login');
      }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return connect(mapStateToProps)(Authenticate);
};



// WEBPACK FOOTER //
// ./src/utils/requireAuth.js